const landingTitle = document.querySelector('.landing-module__title');

if (landingTitle) {
  const landingModuleTimeline = new TimelineLite();
  const landingContent = document.querySelector('.landing-module__content');
  const landingArrow = document.querySelector('.landing-module__scroll-to-next');
  const landingVideo = document.querySelector('.homepage-video');

  landingModuleTimeline
    .to(landingTitle, { duration: 0.4, y: '0', opacity: 1, ease: Power1 })
    .to(landingContent, {
      duration: 0.3,
      opacity: 1,
      ease: Power1,
    })
    .to(landingArrow, { duration: 0.3, opacity: 1, ease: Power1 })
    .fromTo(landingVideo, { opacity: 0 }, { duration: 0.4, opacity: 1, ease: Power1 }, '<');
}

// **************************************************
// Banner animation
// **************************************************
const bgPattern = document.querySelector('.landing-module__bg-pattern');

if ((bgPattern && isLocal()) || (bgPattern && Cookies.get('language_modal'))) {
  animateLandingBackground(bgPattern);
  document.body.classList.add('animate-landing-bg');
}
